import GestaoContext from "context/gestaoContext";
import { useContext } from "react";

export const useGestaoContext = () => useContext(GestaoContext);
